"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var summary_page_configs_routing_1 = require("./summary-page-configs.routing");
var overview_module_1 = require("../main-controls/overview/overview.module");
var ejustice_controls_shared_module_1 = require("../../../shared/ejustice-controls-shared.module");
var idm_portfolio_control_1 = require("@synisys/idm-portfolio-control");
var dialogs_module_1 = require("../../../shared/dialogs/dialogs.module");
var dynamic_component_loader_module_1 = require("../../dynamic-component-loader/dynamic-component-loader.module");
var matrix_dimension_picker_module_1 = require("../../matrix-dimensions-picker/matrix-dimension-picker.module");
var icon_picker_module_1 = require("../../icon-picker/icon-picker.module");
var summary_page_configs_table_component_1 = require("./configs-table/summary-page-configs-table.component");
var overview_config_component_1 = require("./configs-edit/overview-config/overview-config.component");
var overview_config_dialog_component_1 = require("./configs-edit/overview-config/overview-config-dialog/overview-config-dialog.component");
var base_portfolio_config_dialog_component_1 = require("./configs-edit/base-portfolio-config/base-portfolio-config-dialog/base-portfolio-config-dialog.component");
var summary_pages_config_page_component_1 = require("./configs-edit/summary-pages-config-page.component");
var overview_custom_component_dialog_component_1 = require("./configs-edit/overview-config/overview-custom-component-dialog/overview-custom-component-dialog.component");
var overview_single_field_config_component_1 = require("./configs-edit/overview-config/overview-single-field-config/overview-single-field-config.component");
var overview_init_field_properties_pipe_1 = require("../common/pipes/overview-init-field-properties.pipe");
var overview_aggregate_dialog_component_1 = require("./configs-edit/overview-config/overview-aggregate-dialogs/overview-aggregate-dialog.component");
var base_portfolio_config_component_1 = require("./configs-edit/base-portfolio-config/base-portfolio-config.component");
var base_portfolio_helper_service_1 = require("../common/service/base-portfolio-helper.service");
var overview_helper_service_1 = require("../common/service/overview-helper.service");
var summary_page_configs_helper_service_1 = require("../common/service/summary-page-configs-helper.service");
var SummaryPageConfigsModule = /** @class */ (function () {
    function SummaryPageConfigsModule() {
    }
    SummaryPageConfigsModule = __decorate([
        core_1.NgModule({
            imports: [
                forms_1.FormsModule,
                idm_dynamic_forms_ui_1.DynamicFormModule,
                overview_module_1.OverviewModule,
                idm_portfolio_control_1.PortfolioModule,
                summary_page_configs_routing_1.summaryPageConfigsRouter,
                ejustice_controls_shared_module_1.EjusticeControlsSharedModule,
                dialogs_module_1.DialogsModule,
                icon_picker_module_1.IconPickerModule,
                dynamic_component_loader_module_1.DynamicComponentLoaderModule,
                matrix_dimension_picker_module_1.MatrixDimensionPickerModule,
            ],
            declarations: [
                summary_page_configs_table_component_1.SummaryPageConfigsTableComponent,
                overview_config_component_1.OverviewConfigComponent,
                overview_config_dialog_component_1.OverviewConfigDialogComponent,
                base_portfolio_config_dialog_component_1.BasePortfolioConfigDialogComponent,
                base_portfolio_config_component_1.BasePortfolioConfigComponent,
                summary_pages_config_page_component_1.SummaryPagesConfigPageComponent,
                overview_aggregate_dialog_component_1.OverviewAggregateDialogComponent,
                overview_init_field_properties_pipe_1.OverviewInitFieldPropertiesPipe,
                overview_custom_component_dialog_component_1.OverviewCustomComponentDialogComponent,
                overview_single_field_config_component_1.OverviewSingleFieldConfigComponent
            ],
            exports: [
                summary_page_configs_table_component_1.SummaryPageConfigsTableComponent,
                overview_config_component_1.OverviewConfigComponent,
                overview_config_dialog_component_1.OverviewConfigDialogComponent,
                dialogs_module_1.DialogsModule,
                base_portfolio_config_dialog_component_1.BasePortfolioConfigDialogComponent,
                overview_aggregate_dialog_component_1.OverviewAggregateDialogComponent,
                overview_custom_component_dialog_component_1.OverviewCustomComponentDialogComponent,
                overview_single_field_config_component_1.OverviewSingleFieldConfigComponent
            ],
            entryComponents: [
                overview_config_dialog_component_1.OverviewConfigDialogComponent,
                overview_aggregate_dialog_component_1.OverviewAggregateDialogComponent,
                overview_custom_component_dialog_component_1.OverviewCustomComponentDialogComponent,
                base_portfolio_config_dialog_component_1.BasePortfolioConfigDialogComponent
            ],
            providers: [
                summary_page_configs_helper_service_1.SummaryPageConfigsHelperService,
                base_portfolio_helper_service_1.BasePortfolioHelperService,
                overview_helper_service_1.OverviewHelperService,
            ]
        })
    ], SummaryPageConfigsModule);
    return SummaryPageConfigsModule;
}());
exports.SummaryPageConfigsModule = SummaryPageConfigsModule;
//# sourceMappingURL=summary-page-configs.module.js.map